import React from "react";
import { Row, Container } from "reactstrap";
import { ColPrompt, DebounceForText, ColPromptCheckBox } from "./";
import { useSpecificationContextState } from "./useSpecificationContextState";

export default function TabIdentification() {
   const SpecContextState = useSpecificationContextState();

   return (
      <Container fluid className="px-2 py-4">
         <Row className="qualitySpecificationEditRow">
            <ColPrompt title={"Put Up Color / Size"} sizePRP={2} />
            <DebounceForText valuePRP={SpecContextState.specification.putUpSize} maxLengthPRP={50} onChangeString={"putUpSize"} />
         </Row>
         <Row
            className="qualitySpecificationEditRow mt-3"
            children={<ColPrompt title={"Cone Label Information"} headerPRP sizePRP={6} />}
         />
         <hr />
         <Row className="qualitySpecificationEditRow">
            <ColPrompt title={"Label Line 1"} sizePRP={2} />
            <DebounceForText valuePRP={SpecContextState.specification.labelLine1} maxLengthPRP={30} onChangeString={"labelLine1"} />
            <ColPrompt title={"Part Number"} />
         </Row>
         <Row className="qualitySpecificationEditRow">
            <ColPrompt title={"Label Line 2"} sizePRP={2} />
            <DebounceForText valuePRP={SpecContextState.specification.labelLine2} maxLengthPRP={30} onChangeString={"labelLine2"} />
            <ColPrompt title={"Item Description"} />
         </Row>
         <Row className="qualitySpecificationEditRow">
            <ColPrompt title={"Label Line 3"} sizePRP={2} />
            <DebounceForText valuePRP={SpecContextState.specification.labelLine3} maxLengthPRP={30} onChangeString={"labelLine3"} />
            <ColPrompt title={"Other Information"} />
         </Row>
         <Row className="qualitySpecificationEditRow">
            <ColPrompt title={"Label Line 4"} sizePRP={2} />
            <DebounceForText valuePRP={SpecContextState.specification.labelLine4} maxLengthPRP={30} onChangeString={"labelLine4"} />
            <ColPrompt title={"Vendor Name"} />
         </Row>
         <Row
            className="qualitySpecificationEditRow mt-3"
            children={<ColPrompt title={"Customer Pallet Label Information"} headerPRP sizePRP={6} />}
         />
         <hr />
         <Row
            className="qualitySpecificationEditRow"
            children={<ColPromptCheckBox title={"Print Customer Part Number?"} valuePRP={SpecContextState.specification.printPalletPart} onChangeStringPRP={"printPalletPart"} alignPRP={"left"} />}
         />
         <Row
            className="qualitySpecificationEditRow"
            children={<ColPromptCheckBox title={"Print Customer Part Description?"} valuePRP={SpecContextState.specification.printPalletPartDesc} onChangeStringPRP={"printPalletPartDesc"} alignPRP={"left"} />}
         />
         <Row
            className="qualitySpecificationEditRow"
            children={<ColPromptCheckBox title={"Print Customer PO?"} valuePRP={SpecContextState.specification.printPalletCustPO} onChangeStringPRP={"printPalletCustPO"} alignPRP={"left"} />}
         />
         <Row
            className="qualitySpecificationEditRow"
            children={<ColPromptCheckBox title={"Print WO Case Number?"} valuePRP={SpecContextState.specification.printPalletLotNumber} onChangeStringPRP={"printPalletLotNum"} alignPRP={"left"} />}
         />
         <Row className="qualitySpecificationEditRow">
            <ColPrompt title={"# of Labels to Print"} sizePRP={2} />
            <DebounceForText valuePRP={SpecContextState.specification.printPalletCount} onChangeString={"printPalletCount"} sizePRP={2} />
         </Row>
      </Container>
   );
}
